import * as Yup from "yup";
import { validationErrors } from "./validationRules";
import validationUtils from "./validationUtils";

const loginSchema = Yup.object().shape({
  email: validationUtils?.validateEmail(),
  password: Yup.string().required(
    validationErrors?.getRequiredField("password")
  ),
});

export default loginSchema;
